var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"icon",class:[("icon-" + (_vm.props.name)), ((_vm.props.size) + "-size"), ((_vm.props.fill) + "-fill")]})}
var staticRenderFns = []

export { render, staticRenderFns }